import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: "groups" }
const _hoisted_2 = { class: "flex flex-col items-center text-center gap-2 mb-7" }
const _hoisted_3 = { class: "text-[24px] sm:text-[2.4rem] md:text-[3.2rem] font-semibold" }
const _hoisted_4 = { class: "text-[1.6rem] font-medium tracking-[-0.48px]" }
const _hoisted_5 = { class: "rounded-[18px] overflow-hidden border border-white/90 bg-white/60 backdrop-blur-2xl shadow-[0_2px_24px_rgba(0,0,0,0.05)]" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "flex-1 min-w-0" }
const _hoisted_8 = { class: "flex items-center gap-2 mb-[5px]" }
const _hoisted_9 = { class: "text-[15px] font-semibold text-[#0f1f2e] tracking-tight" }
const _hoisted_10 = {
  key: 0,
  class: "inline-flex items-center gap-1 text-[10px] font-medium text-[#7a9aaa] bg-slate-100 rounded-full px-2 py-0.5"
}
const _hoisted_11 = { class: "flex items-center gap-3 flex-wrap" }
const _hoisted_12 = { class: "flex items-center gap-1 text-xs text-[#7a9aaa]" }
const _hoisted_13 = { class: "text-xs text-[#7a9aaa]" }
const _hoisted_14 = { class: "flex items-center gap-2 flex-shrink-0" }
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["disabled", "onClick"]
const _hoisted_17 = {
  key: 0,
  class: "px-6 py-3 text-[13px] text-red-500 bg-red-50 border-t border-red-100"
}
const _hoisted_18 = {
  key: 1,
  class: "px-6 py-10 text-center text-[#7a9aaa]"
}

import type { Group, Disease } from "@/types/domain";
import { useLiveGroups } from "@/components/companionGroups/useLiveGroups";


export default /*@__PURE__*/_defineComponent({
  __name: 'GroupsList',
  props: {
    groups: {},
    memberGroupIds: {},
    joiningGroupId: {},
    joinGroupError: {},
    searchQuery: {},
    showDiseaseDropdown: { type: Boolean },
    selectedDisease: {},
    filteredDiseases: {},
    filteredGroups: {}
  },
  emits: ["view-group", "create-group", "join-group", "leave-group", "update:searchQuery", "update:showDiseaseDropdown", "select-disease", "clear-disease", "search-blur"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const { t, getDiseaseLabel } = useLiveGroups(
  { _skipInit: true },
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  (_e: any, ..._args: any[]) => {},
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h2", _hoisted_3, _toDisplayString(_unref(t)("liveGroups")), 1),
      _createElementVNode("h4", _hoisted_4, _toDisplayString(_unref(t)("subtitle")), 1),
      _createElementVNode("button", {
        class: "inline-flex items-center gap-2 rounded-full bg-[#0f1f2e] text-white px-6 py-3 font-semibold hover:opacity-90 hover:-translate-y-px transition",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('create-group')))
      }, [
        _cache[2] || (_cache[2] = _createElementVNode("svg", {
          width: "12",
          height: "12",
          viewBox: "0 0 24 24",
          fill: "none",
          stroke: "currentColor",
          "stroke-width": "3",
          "stroke-linecap": "round"
        }, [
          _createElementVNode("line", {
            x1: "12",
            y1: "5",
            x2: "12",
            y2: "19"
          }),
          _createElementVNode("line", {
            x1: "5",
            y1: "12",
            x2: "19",
            y2: "12"
          })
        ], -1)),
        _createTextVNode(" " + _toDisplayString(_unref(t)("createGroup")), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredGroups, (group) => {
        return (_openBlock(), _createElementBlock("div", {
          key: group.id,
          class: "flex items-center gap-4 px-6 py-5 border-b border-black/5 last:border-b-0 cursor-pointer transition-all duration-200 hover:bg-white/60 hover:translate-x-1 hover:shadow-[-4px_0_0_0_#0f1f2e] group",
          onClick: ($event: any) => (emit('view-group', group))
        }, [
          _createElementVNode("div", {
            class: _normalizeClass(["w-[7px] h-[7px] rounded-full flex-shrink-0 transition-transform duration-200 group-hover:scale-[1.4]", 
            __props.memberGroupIds.has(group.id) ? 'bg-[#0f1f2e]' : 'bg-[#c8d8e0]'
          ])
          }, null, 2),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("span", _hoisted_9, _toDisplayString(group.name), 1),
              (!group.isPublic)
                ? (_openBlock(), _createElementBlock("span", _hoisted_10, [
                    _cache[3] || (_cache[3] = _createElementVNode("svg", {
                      width: "9",
                      height: "9",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2.5"
                    }, [
                      _createElementVNode("rect", {
                        x: "3",
                        y: "11",
                        width: "18",
                        height: "11",
                        rx: "2"
                      }),
                      _createElementVNode("path", { d: "M7 11V7a5 5 0 0 1 10 0v4" })
                    ], -1)),
                    _createTextVNode(" " + _toDisplayString(_unref(t)("privateGroup")), 1)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("span", _hoisted_12, [
                _cache[4] || (_cache[4] = _createElementVNode("svg", {
                  width: "11",
                  height: "11",
                  viewBox: "0 0 24 24",
                  fill: "none",
                  stroke: "currentColor",
                  "stroke-width": "2",
                  class: "opacity-55"
                }, [
                  _createElementVNode("path", { d: "M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" }),
                  _createElementVNode("circle", {
                    cx: "9",
                    cy: "7",
                    r: "4"
                  })
                ], -1)),
                _createTextVNode(" " + _toDisplayString(group.memberCount) + " " + _toDisplayString(_unref(t)("members")), 1)
              ]),
              _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(getDiseaseLabel)(group.diseaseKey)), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            (__props.memberGroupIds.has(group.id))
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  class: "text-[13px] font-semibold px-4 py-2 rounded-full border border-red-200 text-red-400 hover:border-red-300 hover:bg-red-50 whitespace-nowrap transition",
                  onClick: _withModifiers(($event: any) => (emit('leave-group', group)), ["stop"])
                }, _toDisplayString(_unref(t)("leave")), 9, _hoisted_15))
              : (_openBlock(), _createElementBlock("button", {
                  key: 1,
                  class: "text-[12.5px] font-semibold text-white bg-[#0f1f2e] px-5 py-2 rounded-full whitespace-nowrap transition-opacity duration-200 hover:opacity-80 disabled:opacity-50",
                  disabled: __props.joiningGroupId === group.id,
                  onClick: _withModifiers(($event: any) => (emit('join-group', group)), ["stop"])
                }, _toDisplayString(__props.joiningGroupId === group.id ? _unref(t)("joining") : _unref(t)("join")), 9, _hoisted_16)),
            _cache[5] || (_cache[5] = _createElementVNode("svg", {
              class: "text-[#c8d8e0] flex-shrink-0",
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              _createElementVNode("polyline", { points: "9 18 15 12 9 6" })
            ], -1))
          ])
        ], 8, _hoisted_6))
      }), 128)),
      (__props.joinGroupError)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(__props.joinGroupError), 1))
        : _createCommentVNode("", true),
      (__props.filteredGroups.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
            _createTextVNode(_toDisplayString(_unref(t)("noGroups")) + " ", 1),
            _createElementVNode("button", {
              class: "ml-1 underline text-[#0f1f2e]",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('create-group')))
            }, _toDisplayString(_unref(t)("createFirst")), 1)
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})